import React from 'react';

interface UserRankingItemTop1Props {
  position: number;
  userName: string;
  deliveredCount: number;
  maxCount: number;
}

export const UserRankingItemTop1: React.FC<UserRankingItemTop1Props> = ({
  position,
  userName,
  deliveredCount,
  maxCount,
}) => (
  <div className="flex items-center gap-3 p-3 rounded-xl border transition-all duration-300 bg-blue-50 border-blue-200 shadow-sm group hover:shadow-md">
    <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-black tabular-nums bg-blue-500 text-white">
      {position}
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-sm font-bold truncate text-blue-900">
        {userName}
      </p>
      <div className="h-2 mt-1.5 bg-slate-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500 bg-gradient-to-r from-blue-600 to-blue-400"
          style={{
            width: `${maxCount > 0 ? (deliveredCount / maxCount) * 100 : 0}%`,
          }}
        />
      </div>
    </div>
    <span className="flex-shrink-0 text-sm font-black tabular-nums px-2.5 py-1 rounded-lg bg-blue-100 text-blue-800">
      {deliveredCount}
    </span>
  </div>
);
